<div
  [ngClass]="{
    'double-height': isConsult,
    'normal-height': !isConsult && oneCalendar,
    'position-relative': isExtraHours,
    'square-shaped': squareShaped,
  }"
  class="container"
  [ngStyle]="{ 'background-color': color, color: rhCodeColor }"
  [class.long]="long"
  [class.n-long]="!long"
>
  @if (!long) {
    <div class="width-100" [ngClass]="isConsult ? 'margin-top' : ''" fxLayout="column" fxLayoutAlign="center center">
      <div class="width-100 request-container" fxLayout="row" fxLayoutAlign="center center">
        <div class="icon" *ngIf="displayIcon !== 'ellipse'" fxLayout="row" fxLayoutAlign="center center">
          <mat-icon *ngIf="displayIconType === 'mat-icon'">{{ displayIcon }}</mat-icon>
          <img *ngIf="displayIconType === 'svg-icon'" class="svg-icon" [src]="displayIcon" alt="" />
        </div>

        <div
          *ngIf="text"
          class="text dynamic-scrollbar"
          [matTooltip]="displayTextValue"
          [class.overflow-style]="hasOverflow"
          [ngStyle]="{ fontSize: textSize + 'px' }"
          #textContainer
        >
          {{ displayTextValue }}
          <span *ngIf="false" class="service">
            {{ service }}
          </span>
        </div>
      </div>
      <div class="text consult-text" *ngIf="isConsult">
        {{ isConsult }}
      </div>
    </div>

    @if (withClose) {
      <button type="button" class="trigger-close" (click)="onTriggerRemove()">
        <span class="material-symbols-outlined">close</span>
      </button>
    }

    @if (isExtraHours) {
      <mat-icon class="extra">add</mat-icon>
    }
  } @else {
    <div class="code-container" [ngStyle]="{ fontSize: textSize + 'px', 'border-color': rhCodeColor }">{{ text }}</div>
    <div class="heures" [ngStyle]="{ fontSize: textSize + 'px' }">{{ displayTextValue }}</div>
  }
</div>
